// Navbar-Verhalten: Scroll-Zustand für den "Menu Blur" (§5/§15).
// Offcanvas (mobil) läuft über die Bootstrap-Data-API (siehe main.js).

export function initNavbar() {
  const header = document.querySelector(".site-header");
  if (!header) {
    return;
  }

  // Hysterese (zwei Schwellen): .is-scrolled verkleinert die Header-Höhe (~43px).
  // Bei nur einer Schwelle springt scrollY durch Scroll-Anchoring um diese Höhe
  // zurück über die Schwelle -> Klasse flackert (Navigation "zittert"). Ein
  // Schwellenband größer als die Höhenänderung verhindert das.
  const ON_AT = 64;
  const OFF_AT = 8;
  let scrolled = false;

  const update = () => {
    const y = window.scrollY;
    if (!scrolled && y > ON_AT) {
      scrolled = true;
      header.classList.add("is-scrolled");
    } else if (scrolled && y < OFF_AT) {
      scrolled = false;
      header.classList.remove("is-scrolled");
    }
  };

  update();
  window.addEventListener("scroll", update, { passive: true });
}
